/* Autogenerated file. Do not edit manually. */

import type { PredicateVersion } from '@fuel-connectors/common';
import {
  abi as abi1725561405784,
  bin as bin1725561405784,
  generationDate as generationDate1725561405784,
} from './0x15f8fd16e3281aa89e7567c5f8423f77b34983a8cd7d0a1714100c8bc3d4c8d0';
import {
  abi as abi1728255070813,
  bin as bin1728255070813,
  generationDate as generationDate1728255070813,
} from './0xee4fd742e5d265465885707e0a58a19974dbdff9292ae7345c3988ac90b1478e';

export const PREDICATE_VERSIONS = {
  '0x15f8fd16e3281aa89e7567c5f8423f77b34983a8cd7d0a1714100c8bc3d4c8d0': {
    predicate: { abi: abi1725561405784, bin: bin1725561405784 },
    generatedAt: generationDate1725561405784,
  },
  '0xee4fd742e5d265465885707e0a58a19974dbdff9292ae7345c3988ac90b1478e': {
    predicate: { abi: abi1728255070813, bin: bin1728255070813 },
    generatedAt: generationDate1728255070813,
  },
} as const satisfies Record<string, PredicateVersion>;
